import { db } from "../../firebase";
import { STRATEGIES } from "../Collections";

const strategiesRef = db.collection(STRATEGIES);

export const getAll = () => strategiesRef;
